/**
 * Shared DataTable configurations for consistent styling and behavior
 */
window.DataTableConfig = {
  /**
   * Standard DOM layout for most tables
   */
  standardDom: `
    <"row mb-3"
      <"col-sm-6">
    >
    <"row"
      <"col-sm-12"tr>
    >
    <"row"
      <"col-sm-4 pt-2 pl-1"l>
      <"col-sm-4 pt-3 text-center"i>
      <"col-sm-4 d-flex justify-content-end pt-2"p>
    >
  `,

  /**
   * DOM layout for assignment logs table with search positioning
   */
  assignmentLogDom: `
    <'row mt-2'<'col-sm-12 text-start mb-4 dt-top-left' f>>
    <'row'<'col-sm-12'<'table-responsive 'tr>>>
    <'row mt-2 align-items-center'
      <'col-1 col-sm-1 col-md-1 col-lg-2 col-xl-2'l>
      <'col-1 col-sm-1 col-md-2 col-lg-2 col-xl-3 text-center' i>
      <'col-1 col-sm-1 col-md-3 col-lg-2 col-xl-4 d-flex justify-content-end align-items-center' p>
    >
  `,

  /**
   * DOM layout for Product Reports table with buttons
   */
  productReportDom: `
    <"top d-flex justify-content-between"<"length-menu"l><"search-and-buttons d-flex justify-content-end align-items-center gap-2"fB>>rt<"bottom d-flex justify-content-between"ip><"clear">
  `,

  /**
   * Common default options
   */
  defaults: {
    searchDelay: 1000
  },

  /**
   * Get configuration for standard tables
   * @param {Object} overrides - Additional options to override defaults
   * @returns {Object} DataTable configuration object
   */
  getStandardConfig: function(overrides = {}) {
    return {
      searchDelay: this.defaults.searchDelay,
      dom: this.standardDom,
      ...overrides
    };
  },

  /**
   * Get configuration for assignment logs table
   * @param {Object} overrides - Additional options to override defaults
   * @returns {Object} DataTable configuration object
   */
  getAssignmentLogConfig: function(overrides = {}) {
    return {
      searchDelay: this.defaults.searchDelay,
      dom: this.assignmentLogDom,
      ...overrides
    };
  },

  /**
   * Get configuration for Product Reports table with buttons
   * @param {Object} overrides - Additional options to override defaults
   * @returns {Object} DataTable configuration object
   */
  getProductReportConfig: function(overrides = {}) {
    return {
      searchDelay: 2000,
      dom: this.productReportDom,
      ...overrides
    };
  }
};

// LRPO-5622 — Turbo Drive caches the page DOM on navigation (turbo:before-cache).
// A DataTable whose rows are still in the DOM is cached WITH those rows, so
// navigating back shows STALE rows from a previous context (e.g. the admin Carts
// page showed carts from another event, with the footer reading "0 of 0" while the
// stale rows lingered — the fresh server-side ajax had correctly returned 0). Destroy
// every DataTable on the page before it is cached so the cached snapshot is clean.
//
// Registered ONCE at module load — Turbo keeps the JS context alive across
// navigations, so this does NOT re-add per navigation. Covers every DataTable in the
// app (admin AND exhibitor) plus any table added later, instead of a per-view guard
// that future tables would forget. Guarded so a torn-down table can't throw.
document.addEventListener('turbo:before-cache', function () {
  if (window.$ && window.$.fn && window.$.fn.dataTable) {
    window.$.fn.dataTable.tables().forEach(function (table) {
      try {
        window.$(table).DataTable().clear().destroy();
      } catch (e) {
        // Table already torn down by its own handler — nothing to do.
      }
    });
  }
});
